// Data Health — the rule for "may this issue's picker be offered yet?".
//
// Two issues are fixed by picking from a store-wide list: `missing_location`
// (every Location) and `missing_supplier` (every Supplier). The answer has
// four outcomes:
//
//   ready    — the list arrived and has rows. Render the picker.
//   empty    — the list arrived and the store genuinely has none. Render the
//              route-out ("add a location first"), NOT an empty select.
//   error    — the read failed. Render the failure. Emphatically NOT the empty
//              copy: an empty list is a real answer with a next step, a failed
//              read is not, and telling a merchant to go create a location they
//              already have is worse than telling them nothing.
//   loading  — nothing is known yet. Render neither, or the picker would flash
//              through "you have no locations" on every cold load.
//
// The input is a COUNT, not the rows: the rule never looks at an option, and
// one caller (missing_supplier) reads a `page_size=1` count rather than the
// whole supplier list.

export const FIX_OPTIONS_STATE = {
  LOADING: 'loading',
  ERROR: 'error',
  EMPTY: 'empty',
  READY: 'ready',
};

/**
 * @param {object} read
 * @param {boolean} read.isLoading  the options read is in flight
 * @param {boolean} read.isError    the options read failed
 * @param {number} read.count       how many options exist (0 until they arrive)
 * @returns {'loading'|'error'|'empty'|'ready'}
 */
export function fixOptionsState({ isLoading, isError, count }) {
  // Error first, so a read that reports both states never falls through to
  // the empty copy — the one screen that must never appear on a failed read.
  if (isError) return FIX_OPTIONS_STATE.ERROR;
  if (isLoading) return FIX_OPTIONS_STATE.LOADING;
  return count === 0 ? FIX_OPTIONS_STATE.EMPTY : FIX_OPTIONS_STATE.READY;
}
